import { AnimatedComponent } from 'sane-ui'
import { SplitText } from 'gsap/all'

class HeroCopy extends AnimatedComponent {
  constructor ($el, args) {
    args.offset = '95%'
    super($el, args)
  }

  buildTimelineIn () {
    const $titleInner = this.$el.find('.hero-copy__title__inner')
    const titleInnerST = new SplitText($titleInner, { type: 'chars' })
    const $copy = this.$el.find('.hero-copy__copy p')
    const copyST = new SplitText($copy, { type: 'lines' })

    this.timelineIn
      .set(this.$el.find('.hero-copy__inner'), { autoAlpha: 1 })
      .from(titleInnerST.chars, { duration: 0.5, opacity: 0, ease: 'none', stagger: 0.025 }, 0)
      .from(titleInnerST.chars, { duration: 0.5, x: '80%', ease: 'power3.out', stagger: 0.025 }, 0)
      .from(copyST.lines, { duration: 0.4, opacity: 0, y: '20%', ease: 'power2.out', stagger: 0.075 }, 0)

    $(window).one('resize', () => { copyST.revert() })
  }
}

export default HeroCopy



// WEBPACK FOOTER //
// ./scripts/components/HeroCopy.js